import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useBook } from "@/context/BookContext";
import { Page, Header, Badge, Img } from "@/components/common";

export default function Books() {
  const { books, loadBooks, setBookId, bookId } = useBook();
  const nav = useNavigate();
  useEffect(() => { loadBooks(); }, [loadBooks]);
  const del = async (e, b) => {
    e.stopPropagation();
    if (!window.confirm(`"${b.title}" silinsin mi?`)) return;
    await api.delete(`/books/${b.id}`);
    toast.success("Kitap silindi");
    loadBooks();
  };
  return (
    <Page crumbs={["Kitaplar"]}>
      <Header title="Kitaplarım" sub="Tüm kitap projeleriniz. Bir kitabı seçerek çalışma alanını açın.">
        <Link to="/kitaplar/yeni" className="btn-teal px-6 py-3 flex items-center gap-2" data-testid="books-new-btn"><Plus size={18} /> Yeni kitap oluştur</Link>
      </Header>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-5">
        {books.map((b) => (
          <div key={b.id} onClick={() => { setBookId(b.id); nav(`/kitaplar/${b.id}`); }} data-testid={`book-card-${b.id}`}
            className={`card-z p-2 cursor-pointer group hover:shadow-lg transition-shadow ${b.id === bookId ? "ring-2 ring-[var(--teal)]" : ""}`}>
            <div className="relative overflow-hidden rounded-lg">
              <Img src={b.cover?.image_url} className="w-full aspect-[2/3] group-hover:scale-[1.03] transition-transform duration-500" />
              <Badge s={b.status} className="absolute top-2 right-2 bg-white/90" />
              <button onClick={(e) => del(e, b)} className="absolute bottom-2 right-2 bg-white/90 p-1.5 rounded-md text-[#d1453b] opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`delete-book-${b.id}`}><Trash2 size={14} /></button>
            </div>
            <div className="px-2 py-3">
              <div className="font-serif-d font-semibold text-navy">{b.title}</div>
              <div className="text-xs text-[#6b7a8c]">{b.author} • {b.age_group} • {b.page_count} sayfa</div>
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
}
